import { render, staticRenderFns } from "./InputFileBase.vue?vue&type=template&id=7e784bda&scoped=true&lang=pug&"
import script from "./InputFileBase.vue?vue&type=script&lang=ts&"
export * from "./InputFileBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e784bda",
  null
  
)

export default component.exports